// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import { BrowserRouter } from 'react-router-dom';

const root = createRoot(document.getElementById('root'));

// Disable browser's automatic scroll restoration
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Global scroll to top on navigation - intercepts ALL navigation
// Scroll immediately, synchronously, before any rendering
const scrollToTopImmediate = () => {
  // Disable smooth scrolling temporarily
  const html = document.documentElement;
  const originalScrollBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  
  window.scrollTo(0, 0);
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  
  // Also scroll root element
  const root = document.getElementById('root');
  if (root) {
    root.scrollTop = 0;
  }
  
  // Also try scrollIntoView
  try {
    document.documentElement.scrollIntoView({ behavior: 'instant', block: 'start' });
    if (document.body) {
      document.body.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  } catch (e) {
    // Fallback for older browsers
  }
  
  // Restore original scroll behavior after a delay
  setTimeout(() => {
    html.style.scrollBehavior = originalScrollBehavior || '';
  }, 100);
};

let lastPath = window.location.pathname;
const originalPushState = window.history.pushState;
const originalReplaceState = window.history.replaceState;

window.history.pushState = function(...args) {
  // Scroll BEFORE navigation
  scrollToTopImmediate();
  const result = originalPushState.apply(window.history, args);
  // Scroll AFTER navigation (immediate, no setTimeout)
  scrollToTopImmediate();
  // Also scroll in next tick to catch any delayed updates
  setTimeout(scrollToTopImmediate, 0);
  setTimeout(scrollToTopImmediate, 10);
  setTimeout(scrollToTopImmediate, 50);
  return result;
};

window.history.replaceState = function(...args) {
  // Scroll BEFORE navigation
  scrollToTopImmediate();
  const result = originalReplaceState.apply(window.history, args);
  // Scroll AFTER navigation (immediate, no setTimeout)
  scrollToTopImmediate();
  // Also scroll in next tick to catch any delayed updates
  setTimeout(scrollToTopImmediate, 0);
  setTimeout(scrollToTopImmediate, 10);
  setTimeout(scrollToTopImmediate, 50);
  return result;
};

// Listen for popstate (back/forward buttons)
window.addEventListener('popstate', () => {
  scrollToTopImmediate();
});

// Monitor pathname changes periodically (but not too aggressively)
const checkPathChange = () => {
  const currentPath = window.location.pathname;
  if (currentPath !== lastPath) {
    lastPath = currentPath;
    scrollToTopImmediate();
  }
};

// Check for path changes periodically (every 50ms is reasonable)
setInterval(checkPathChange, 50);

root.render(
  <ErrorBoundary>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);

reportWebVitals();
console.log('CSS changes loaded at:', new Date().toISOString());
